/* The Grand Festive Glow Box (gg-). Buy Now follows the same flow as festive-glow-combo.js / product-form.js:
   /cart/add.js → openFlexyCheckout, else /checkout. */
(() => {
  const root = document.querySelector('[data-gg]');
  if (!root) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hasIO = 'IntersectionObserver' in window;
  const $ = (s) => root.querySelector(s);
  const $$ = (s) => [...root.querySelectorAll(s)];

  const toastEl = $('[data-gg-toast]');
  function toast(msg) {
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toast.t);
    toast.t = setTimeout(() => toastEl.classList.remove('is-on'), 3200);
  }

  /* ---------- Cart / Buy Now ---------- */
  async function fetchCart() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      return res.ok ? await res.json() : null;
    } catch {
      return null;
    }
  }
  async function addToCart(item) {
    const res = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Could not add to cart');
    }
    const data = await res.json();
    document.dispatchEvent(new CustomEvent('cart:updated'));
    return data;
  }
  async function goToCheckout(item, addResponse) {
    const cart = await fetchCart();
    const flexyItems = [{ variant_id: item.id, quantity: item.quantity }];
    const handoff = {
      flow: 'buynow',
      source: 'mukhlis-grand-glow-box',
      items: flexyItems,
      cart,
      addResponse: addResponse || null,
      attributes: cart?.attributes || {},
      note: cart?.note || '',
      token: cart?.token || '',
      item_count: cart?.item_count ?? 1,
      total_price: cart?.total_price,
      currency: cart?.currency,
      createdAt: Date.now(),
    };
    window.MukhlisCheckoutHandoff = handoff;
    document.dispatchEvent(new CustomEvent('mukhlis:checkout-ready', { detail: handoff }));
    if (typeof window.openFlexyCheckout === 'function' && window.flexypeCheckoutActive === true) {
      window.openFlexyCheckout('buy_now_button', undefined, flexyItems, Promise.resolve(addResponse || cart || { items: flexyItems }));
      return;
    }
    location.href = '/checkout';
  }

  const actionBtns = $$('[data-gg-buy], [data-gg-add]');
  let busy = false;
  function setLoading(on, active) {
    actionBtns.forEach((b) => {
      if (on) {
        b.dataset.was = b.disabled ? '1' : '';
        b.disabled = true;
      } else b.disabled = b.dataset.was === '1';
    });
    const label = active.querySelector('.gg-btn__label');
    if (on) {
      label.dataset.label = label.textContent;
      label.textContent = 'Please wait…';
    } else if (label.dataset.label) label.textContent = label.dataset.label;
  }
  async function run(btn, mode) {
    if (busy) return;
    const form = btn.closest('form') || $('[data-gg-form]');
    const item = { id: Number(form?.querySelector('[name="id"]')?.value || root.dataset.variantId || 0), quantity: 1 };
    if (!item.id) return toast('This product is unavailable right now.');
    busy = true;
    setLoading(true, btn);
    try {
      const added = await addToCart(item);
      if (mode === 'buy') return await goToCheckout(item, added);
      // `added` = the /cart/add.js response, so the Smart Cart can render without another /cart.js round trip
      document.dispatchEvent(new CustomEvent('cart:confirm', { detail: { message: `${root.dataset.productTitle} added to cart.`, added } }));
    } catch (err) {
      // Network failures never show the raw "Failed to fetch" / "Load failed"
      const offline = err instanceof TypeError || /failed to fetch|load failed|networkerror/i.test(err.message || '');
      toast(offline ? 'Network slow hai, dobara try karein' : err.message || 'Something went wrong. Please try again.');
    } finally {
      busy = false;
      setLoading(false, btn);
    }
  }
  actionBtns.forEach((b) =>
    b.addEventListener('click', (e) => {
      e.preventDefault();
      run(b, b.hasAttribute('data-gg-buy') ? 'buy' : 'add');
    })
  );

  /* ---------- Chips → bottom sheet (mobile) / inline panel (desktop) ---------- */
  const sheet = $('[data-gg-sheet]');
  const panel = $('[data-gg-panel]');
  const sheetTitle = $('[data-gg-sheet-title]');
  const sheetBody = $('[data-gg-sheet-body]');
  const desk = matchMedia('(min-width: 1024px)');
  let chip = null;
  let modal = false;

  function lock(on) {
    const sw = innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.overflow = on ? 'hidden' : '';
    document.body.style.paddingRight = on && sw > 0 ? `${sw}px` : '';
  }
  function openSheet(btn) {
    const tpl = $(`template[data-gg-ans="${btn.dataset.ggChip}"]`);
    if (!tpl) return;
    if (chip && chip !== btn) chip.setAttribute('aria-expanded', 'false');
    chip = btn;
    btn.setAttribute('aria-expanded', 'true');
    sheetTitle.textContent = tpl.dataset.title;
    sheetBody.replaceChildren(tpl.content.cloneNode(true));
    modal = !desk.matches;
    if (modal) panel.setAttribute('aria-modal', 'true');
    else panel.removeAttribute('aria-modal');
    sheet.classList.toggle('is-modal', modal);
    sheet.hidden = false;
    if (modal) lock(true);
    requestAnimationFrame(() => sheet.classList.add('is-open'));
    panel.focus({ preventScroll: !modal });
  }
  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    if (modal) lock(false);
    chip?.setAttribute('aria-expanded', 'false');
    setTimeout(() => (sheet.hidden = true), modal && !reduce ? 260 : 0);
    chip?.focus({ preventScroll: true });
  }
  $$('[data-gg-chip]').forEach((b) =>
    b.addEventListener('click', () => (chip === b && !sheet.hidden ? closeSheet() : openSheet(b)))
  );
  $$('[data-gg-close]').forEach((b) => b.addEventListener('click', () => closeSheet()));
  sheet?.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') return closeSheet();
    if (e.key !== 'Tab' || !modal) return;
    const f = [...panel.querySelectorAll('button:not([disabled]), a[href], input')];
    const first = f[0];
    const last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* ---------- Light the room ---------- */
  const litBtn = $('[data-gg-lit]');
  litBtn?.addEventListener('click', () => {
    const on = root.classList.toggle('gg--lit');
    litBtn.setAttribute('aria-pressed', String(on));
  });

  if (!hasIO) return $$('[data-gg-zone]').forEach((z) => z.classList.add('is-live'));

  /* ---------- Entrance: below-the-fold blocks fade up once ---------- */
  if (!reduce) {
    root.classList.add('gg-js');
    const revealIO = new IntersectionObserver(
      (es) =>
        es.forEach((e) => {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          revealIO.unobserve(e.target);
        }),
      { rootMargin: '0px 0px -10% 0px' }
    );
    $$('.gg-rv').forEach((el) => revealIO.observe(el));
  }

  /* ---------- Sticky bar: hidden only while the hero Buy Now is really visible (not under the fixed header) ---------- */
  const sticky = $('[data-gg-sticky]');
  const heroBuy = $('#gg-buy-hero') || $('[data-gg-hero-cta]');
  let stickyTick = false;
  const updateSticky = () => {
    stickyTick = false;
    const headerH = document.querySelector('[data-header-group-spacer]')?.offsetHeight || 0;
    const r = heroBuy.getBoundingClientRect();
    const visible = r.bottom > headerH + 8 && r.top < innerHeight - 8;
    sticky.classList.toggle('is-on', !visible);
    sticky.setAttribute('aria-hidden', String(visible));
  };
  addEventListener('scroll', () => { if (!stickyTick) { stickyTick = true; requestAnimationFrame(updateSticky); } }, { passive: true });
  addEventListener('resize', updateSticky);
  updateSticky();

  /* ---------- Pause loops off-screen (Ken Burns, flames, band, particles) ---------- */
  const liveIO = new IntersectionObserver((es) => es.forEach((e) => e.target.classList.toggle('is-live', e.isIntersecting)));
  $$('[data-gg-zone]').forEach((el) => liveIO.observe(el));
})();
